module.exports = __webpack_public_path__ + "72ffe6c592f57a966cde76b7d590fd05.eot";